import React from 'react';

import strings from 'src/strings';

import ApplicationPage from '../ApplicationPage';

const OverviewView = () => {
  return <ApplicationPage title={strings.APPLICATION}></ApplicationPage>;
};

export default OverviewView;
